export default __webpack_public_path__ + "static/4-bb52752b106b89f96eed9120f5b25307.svg";